import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const purchaseWithPurchaseRolesRBAC = {
  pageID: 'e9582acd49c5d67f936da83ea65aa2cf',
  elementID: {
    ViewPage: '1d70fd6d7a5c74fe2b1a41828735d3c9',
    ButtonToggleStatus: 'cc0db1e89eadc8877d419673b8ca54b1',
    ButtonCreatePWP: 'b42f1b55574bc1ab6a1f23ec5c30934c',
    ButtonPriorityPWP: '4a7608bcae8401875a8152f101ae8130',
    ButtonEditPWP: '8746bdc0d90c2b035721222a99a1f898',
  },
} as const

export const useRBACPurchaseWithPurchasePage = createUseRBAC(
  purchaseWithPurchaseRolesRBAC.elementID,
)

export type UseRBACPurchaseWithPurchasePageType = ReturnType<typeof useRBACPurchaseWithPurchasePage>
